// src/calculateGasMargin.ts
function calculateGasMargin(value) {
  return value.mul(120).div(100);
}
export {
  calculateGasMargin
};
